import { CENSUS } from 'sites/routes'
import {
  INVALID_PROFILE_URL_KEY,
  INVALID_PROFILE_EXCEPTION
} from 'core/constants/exceptions'

function redirectCensus(e) {
  rg4js('send', {
    error: e,
    customData: {
      tags: ['severity:mid', 'redirect:census']
    }
  })

  console.error(e)

  const notification =
    e === INVALID_PROFILE_EXCEPTION ? `?notification=${INVALID_PROFILE_URL_KEY}` : ''

  // document.location.assign(`${CENSUS}${notification}`)
}

export default redirectCensus
